import { ChangeDetectionStrategy, Component } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-tachograph-empty-state',
  standalone: true,
  imports: [TranslateModule],
  templateUrl: './tachograph-empty-state.component.html',
  styleUrls: ['./tachograph-empty-state.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TachographEmptyStateComponent {

}
